import React from "react";
import { Phone, MapPin, Clock, Star } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-neutral-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-serif text-3xl text-[#0F172A]">Chand Book Depot</div>
          <p className="mt-3 text-sm text-neutral-600 leading-relaxed max-w-md">
            A trusted neighbourhood bookstore in Rohini serving students and readers for years. School books,
            stationery, project material and study assignments — all under one roof.
          </p>
          <div className="mt-5 flex items-center gap-2 text-sm">
            <Star size={16} className="fill-[#E05A47] text-[#E05A47]" />
            <span className="font-medium">3.8</span>
            <span className="text-neutral-500">· 747 Reviews on Google</span>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-4">Visit</div>
          <div className="flex gap-2 text-sm text-neutral-700 mb-3">
            <MapPin size={16} className="mt-0.5 text-[#4A6741]" />
            <span>Sector-1, B-779, Kanjhawala Rd,<br/>Avantika, Rohini, Delhi, 110085</span>
          </div>
          <div className="flex gap-2 text-sm text-neutral-700">
            <Clock size={16} className="mt-0.5 text-[#4A6741]" />
            <span>Closed · Opens 9 am Tue</span>
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mb-4">Reach Us</div>
          <a href="tel:09211813521" data-testid="footer-call-link" className="flex gap-2 text-sm text-neutral-700 hover:text-[#E05A47]">
            <Phone size={16} className="mt-0.5 text-[#4A6741]" />
            092118 13521
          </a>
        </div>
      </div>
      <div className="border-t border-neutral-200 py-5 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} Chand Book Depot · All rights reserved.
      </div>
    </footer>
  );
}
